import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { extrairMensagemErro } from '~/Utils/Helpers';
import {
  cadastrarTipoContaInterna,
  atualizarTipoContaInterna,
} from '~/Services/Service';

const validationSchema = Yup.object().shape({
  descricao: Yup.string()
    .trim()
    .required('Descrição é obrigatória')
    .max(30, 'Descrição deve ter no máximo 30 caracteres'),
  centro: Yup.string()
    .required('Lança Centro é obrigatório')
    .oneOf(['S', 'N'], 'Lança Centro deve ser S ou N'),
  bx_valida: Yup.string()
    .oneOf(['', 'S', 'N'], 'Considera Baixa Válida deve ser S, N ou vazio')
    .nullable(),
});

const ModalTipoContaInterna = ({ show, onHide, tipo, onSalvar }) => {
  const ehEdicao = tipo != null;

  const initialValues = ehEdicao
    ? {
        codigo: tipo.codigo,
        descricao: tipo.descricao || '',
        centro: tipo.centro || 'N',
        bx_valida: tipo.bx_valida || '',
      }
    : { descricao: '', centro: 'N', bx_valida: '' };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        descricao: values.descricao,
        centro: values.centro,
        bx_valida: values.bx_valida === '' ? null : values.bx_valida,
      };

      if (ehEdicao) {
        await atualizarTipoContaInterna({
          codigo: values.codigo,
          ...payload,
        });
        toast.success('Tipo atualizado com sucesso');
      } else {
        await cadastrarTipoContaInterna(payload);
        toast.success('Tipo cadastrado com sucesso');
      }

      onSalvar();
      onHide();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#0747a6', color: '#fff' }}
      >
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          {ehEdicao ? 'Editar Tipo de Conta Interna' : 'Novo Tipo de Conta Interna'}
        </Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              {ehEdicao && (
                <Form.Group as={Row} className="mb-2">
                  <Form.Label
                    column
                    sm={5}
                    className="text-right font-weight-bold"
                  >
                    Código
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control
                      type="text"
                      value={formik.values.codigo}
                      readOnly
                      disabled
                      style={{ backgroundColor: '#f5f5f5' }}
                    />
                  </Col>
                </Form.Group>
              )}

              <Form.Group as={Row} className="mb-2">
                <Form.Label
                  column
                  sm={5}
                  className="text-right font-weight-bold"
                >
                  Descrição <span className="text-danger">*</span>
                </Form.Label>
                <Col sm={7}>
                  <Field
                    as={Form.Control}
                    type="text"
                    name="descricao"
                    maxLength={30}
                    isInvalid={
                      formik.touched.descricao && !!formik.errors.descricao
                    }
                  />
                  <ErrorMessage
                    name="descricao"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label
                  column
                  sm={5}
                  className="text-right font-weight-bold"
                >
                  Lança Centro <span className="text-danger">*</span>
                </Form.Label>
                <Col sm={7}>
                  <Form.Control
                    as="select"
                    name="centro"
                    value={formik.values.centro}
                    onChange={formik.handleChange}
                    isInvalid={
                      formik.touched.centro && !!formik.errors.centro
                    }
                  >
                    <option value="N">Não</option>
                    <option value="S">Sim</option>
                  </Form.Control>
                  <ErrorMessage
                    name="centro"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label
                  column
                  sm={5}
                  className="text-right font-weight-bold"
                >
                  Considera Baixa Válida
                </Form.Label>
                <Col sm={7}>
                  <Form.Control
                    as="select"
                    name="bx_valida"
                    value={formik.values.bx_valida}
                    onChange={formik.handleChange}
                    isInvalid={
                      formik.touched.bx_valida && !!formik.errors.bx_valida
                    }
                  >
                    <option value="">— (não definido)</option>
                    <option value="N">Não</option>
                    <option value="S">Sim</option>
                  </Form.Control>
                  <ErrorMessage
                    name="bx_valida"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </Col>
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={onHide}
                disabled={formik.isSubmitting}
              >
                Cancelar
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? 'Salvando...' : 'Salvar'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalTipoContaInterna;
